/**
 * Truncate the given string to the given max text length.
 *
 * @param value String
 * @param maxTextLength Number
 * @returns String
 */
export const truncateText = (value, maxTextLength = 80) => {
    if (!value) {
        return ''
    }

    value = value.trim()

    if (value.length <= maxTextLength) {
        return value
    }

    return `...${value.substring(value.length - maxTextLength)}`
}
